import { render } from "./mainnav.vue?vue&type=template&id=806a1808"
import script from "./mainnav.vue?vue&type=script&lang=js"
export * from "./mainnav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__